
import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AmplifyRoutingService } from '../../Core/services/amplify-routing.service';
import { WireComponent } from '../../Wire/components/wire.component';
import { WireService } from '../../Wire/services/wire.service';
import { AmplifyRouteTypeEnum } from '../enums/amplify-route-type.enum';

@Injectable()
export class WireDeactivateGuard implements CanDeactivate<WireComponent> {
    constructor(
        public wireService: WireService,
        public amplifyRoutingService: AmplifyRoutingService
    ) {}

    canDeactivate(component: WireComponent): Observable<boolean> {
        const destinationRoute = this.amplifyRoutingService.getNextRoute();

        if (
            destinationRoute
            && destinationRoute.type === AmplifyRouteTypeEnum.wire
            && !destinationRoute.value
        ) {
            // New wire case, the amplify dialog checks for unsaved before it opens, when navigation happens it's already been asked, don't ask again
            return of(true);
        }

        return this.wireService.canDeactivate$();
    }
}
